export const CStatisticsSectionFragment = `
  fragment statisticsSection on statisticsSection_MatrixField {
    ... on statisticsSection_block_Entry {
      heading
      stats: statItems {
        ... on stats_Entry {
          heading
          subHeading
        }
      }
    }
  }
`
